import { Vue } from 'ui.vue';
import { Vuex } from 'ui.vue.vuex';
import BasketComponent from "./basket-component.vue";

import { store, MAX_BASKET_QUANTITY } from "kanzler.basket-store";

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.basket').forEach((element) => {
		Vue.create({
			el: element,
			template: `
				<basket-component
					:result="result"
					:params="params"
					:template="template"
					:signedParamsString="signedParamsString"
					:siteId="siteId"
					:siteTemplateId="siteTemplateId"
					:overflowLimit="${MAX_BASKET_QUANTITY}"
				/>
			`,
			data: () => {
				return JSON.parse(JSON.stringify(window[element.dataset.dataId]))
			},
			components: {
				'basket-component': BasketComponent,
			},
			methods: {
				...Vuex.mapMutations(['configure']),
				...Vuex.mapActions(['commitBasketResult']),
			},
			mounted() {
				this.configure({
					ajaxUrl: this.ajaxUrl,
					pathToBasket: document.location.pathname,
					actionVariable: this.params.ACTION_VARIABLE,
					siteId: this.siteId,
					siteTemplateId: this.siteTemplateId,
					template: this.template,
					signedParamsString: this.signedParamsString,
				});
				this.commitBasketResult(this.result);
			},
			store
		});
	});
});
